import { getOffers, getLineGraph } from "@/api/offers";
import Vue from "vue";

const state = {
  list: [],
  chart: [],
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_CHART(state, chart) {
    state.chart = chart;
  },
};

const actions = {
  async getOffers({ commit }, payload) {
    try {
      const response = await getOffers(payload);
      if (response && response.code === 200 && response.data) {
        commit("SET_LIST", response.data);
        return response;
      } else {
        throw response.message;
      }
    } catch (e) {
      Vue.$toast.error(e, {
        duration: 0,
      });
    }
  },
  async getLineGraph({ commit }, payload) {
    try {
      const response = await getLineGraph(payload);

      if (response?.code === 200 && response.data) {
        const charts = response.data.reduce(
          (acc, item) => {
            acc.items.push(item.count);
            acc.labels.push(formatDate(item.report_date));
            return acc;
          },
          { items: [], labels: [] }
        );
        commit("SET_CHART", charts);
        return response;
      } else {
        throw response.message;
      }
    } catch (e) {
      Vue.$toast.error(e, {
        duration: 0,
      });
    }
  },
};

function formatDate(dateStr) {
  const date = new Date(dateStr);

  const options = {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  };

  const formattedDate = date.toLocaleDateString("en-US", options);

  return formattedDate;
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
